import React, { useEffect, useState } from 'react';
import ReactExport from 'react-export-excel';
import { Button } from '@material-ui/core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = (props) => {
   const [dataSet, setDataset] = useState([]);

   useEffect(() => {
      setDataset(props.downloadData);
   }, [props.downloadData]);

   return (
      <ExcelFile
         ExcelFile
         element={
            <Button
               variant='contained'
               style={{ backgroundColor: '#27A844', color: 'white' }}
               size='small'
               startIcon={<FontAwesomeIcon icon={faDownload} />}
            >
               ดาวน์โหลดไฟล์
            </Button>
         }
      >
         <ExcelSheet data={dataSet} name='Employees'>
            <ExcelColumn label='ปี' value='year' />
            <ExcelColumn label='รหัสหลักเกณฑ์' value='ruleCode' />
            <ExcelColumn label='ชื่อหลักเกณฑ์' value='ruleNameTh' />
            <ExcelColumn
               label='เงื่อนไขการได้รับหลักเกณฑ์'
               value='ruleConditionTh'
            />
            <ExcelColumn
               label='แหล่งที่มาข้อมูล'
               value='ruleReferenceDescription'
            />
            <ExcelColumn label='สร้างโดย' value='createdBy' />
            <ExcelColumn label='แก้ไขโดย' value='updatedBy' />
            <ExcelColumn label='วันที่สร้าง' value='createdDateLabel' />
            <ExcelColumn label='วันที่แก้ไข' value='updatedDateLabel' />
            {/* <ExcelColumn label="Marital Status"
                    value={(col) => col.is_married ? "Married" : "Single"} /> */}
         </ExcelSheet>
      </ExcelFile>
   );
};

export default Download;
